var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.masquerading.status
    ? _c(
        "div",
        {
          staticClass:
            "p-3 bg-black text-white text-center border-t-8 border-red",
        },
        [
          _c("div", { staticClass: "flex justify-center" }, [
            _c("div", { staticClass: "pr-1" }, [
              _vm._v(
                "\n      Return to " +
                  _vm._s(_vm.masquerading.name) +
                  "'s account\n    "
              ),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "text-white hover:text-red",
                on: { click: _vm.stopMasquerading },
              },
              [_c("LogoutIcon")],
              1
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }